import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { DEMO_CREDENTIALS, listAccountNames } from '../utils/localApi';

export default function Login() {
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const [mode, setMode] = useState('login');
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  // 本机已有档案数：用来向访问者说明「一个账号一份数据」确实生效
  const [accountNames] = useState(() => listAccountNames());

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!username || !password) {
      setError('请输入用户名和密码');
      return;
    }
    if (mode === 'register' && password !== confirmPassword) {
      setError('两次输入的密码不一致');
      return;
    }
    setLoading(true);
    try {
      if (mode === 'login') {
        await login(username, password);
      } else {
        await register(username, password);
      }
      navigate('/');
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  // 一键进入演示账号：作品集场景下，让访问者零输入就能看到完整产品，
  // 同时又不放弃「登录 + 数据隔离」这套正确结构。
  const handleDemoLogin = async () => {
    setError('');
    setLoading(true);
    try {
      await login(DEMO_CREDENTIALS.username, DEMO_CREDENTIALS.password);
      navigate('/');
    } catch (err) {
      setError(err.message);
    }
    setLoading(false);
  };

  return (
    <div className="app-container" style={{ maxWidth: 420, margin: '0 auto', paddingTop: 40 }}>
      <div style={{ textAlign: 'center', marginBottom: 24 }}>
        <div style={{ fontSize: 56, marginBottom: 8 }}>💊</div>
        <h1 className="page-title" style={{ marginBottom: 4 }}>小药盒</h1>
        <p style={{ color: 'var(--text-secondary)' }}>关爱健康，按时服药</p>
      </div>

      {/* 演示入口置于最上：鼠标还没移开就已经能点进去 */}
      <div className="card" style={{ border: '1px solid var(--primary-color)' }}>
        <div style={{ fontSize: 'var(--font-size-base)', fontWeight: 700, marginBottom: 6 }}>
          🎯 只想看看效果？
        </div>
        <p style={{ color: 'var(--text-secondary)', fontSize: 'var(--font-size-small)', lineHeight: 1.7, marginBottom: 12 }}>
          一键进入预置好的演示账号 <b>{DEMO_CREDENTIALS.username}</b>，
          里面已有 4 种慢病药、近 15 天的服药记录和打卡徽章，可以直接点。
        </p>
        <button
          className="btn-primary"
          style={{ minHeight: 52, width: '100%' }}
          onClick={handleDemoLogin}
          disabled={loading}
        >
          {loading ? '进入中...' : '一键体验演示账号'}
        </button>
      </div>

      <div className="card">
        <div style={{ display: 'flex', marginBottom: 24 }}>
          <button
            className={mode === 'login' ? 'btn-primary' : 'btn-secondary'}
            style={{ flex: 1, minHeight: 48 }}
            onClick={() => { setMode('login'); setError(''); }}
          >
            登录
          </button>
          <button
            className={mode === 'register' ? 'btn-primary' : 'btn-secondary'}
            style={{ flex: 1, minHeight: 48 }}
            onClick={() => { setMode('register'); setError(''); }}
          >
            注册
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 16 }}>
            <label className="label">用户名</label>
            <input
              className="input-field"
              value={username}
              onChange={e => setUsername(e.target.value)}
              placeholder="请输入用户名"
              autoComplete="username"
            />
          </div>

          <div style={{ marginBottom: 16 }}>
            <label className="label">密码</label>
            <input
              className="input-field"
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="请输入密码"
              autoComplete={mode === 'login' ? 'current-password' : 'new-password'}
            />
          </div>

          {mode === 'register' && (
            <div style={{ marginBottom: 16 }}>
              <label className="label">确认密码</label>
              <input
                className="input-field"
                type="password"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                placeholder="请再次输入密码"
                autoComplete="new-password"
              />
            </div>
          )}

          {error && <p className="error-text">{error}</p>}

          <button className="btn-primary btn-large" type="submit" disabled={loading}>
            {loading ? '请稍候...' : (mode === 'login' ? '登 录' : '注 册')}
          </button>
        </form>

        {mode === 'login' && (
          <p style={{ textAlign: 'center', marginTop: 16, color: 'var(--text-secondary)', fontSize: 'var(--font-size-small)' }}>
            还没有账号？<span style={{ color: 'var(--primary-color)', fontWeight: 600, cursor: 'pointer' }} onClick={() => { setMode('register'); setError(''); }}>立即注册</span>
          </p>
        )}
      </div>

      <div style={{ marginTop: 20, color: 'var(--text-light)', fontSize: 'var(--font-size-small)', lineHeight: 1.8, textAlign: 'center' }}>
        <p>每位用户的数据相互独立，一个账号一份数据。</p>
        <p>
          本机已有 <b>{accountNames.length}</b> 个本地档案
          {accountNames.length > 0 ? `（${accountNames.join('、')}）` : ''}
          —— 换账号登录即可验证数据是隔离的。
        </p>
        <p style={{ marginTop: 6 }}>
          演示版数据仅保存在你自己的浏览器中，账号也只在本机有效，不会上传。
        </p>
      </div>
    </div>
  );
}
